module.exports = __webpack_public_path__ + "static/media/f_id_front.b92ec727.svg";